import React, { Component } from 'react'

export default class RecentPosts extends Component {
  renderPost (boxItem, index) {
    return (
      <article className="postBox" key={index}>
        <div
          className="thumb"
          style={{backgroundImage: `url(/imgs/${boxItem.img})`}}
          onClick={() => this.gotToPost(boxItem.index)}>
        </div>
        <div className="bottom">
          <a className="title">{boxItem.title}</a>
          <div className="footerBox">
            <span className="views">
              <i className="fa fa-eye"></i>
              {boxItem.views}
            </span>
            <a>Escreva um comentário</a>
            <span className="like">
              <i className="fa fa-heart"></i>
            </span>
          </div>
        </div>
      </article>
    )
  }

  gotToPost (selectedPost) {
    this.props.requestRecentPost(selectedPost)
  }

  render() {
    const data = this.props.recentPost

    return (
      <div className="recentPosts squad clear">
        <nav className="clear">
          <p className="left">Posts recentes</p>
          <a href="/blog" className="right">Ver Tudo</a>
        </nav>
        <div className="boxPostContainer">
          {data.slice(0, 3).map((data, index) => (this.renderPost(data, index)))}
        </div>
        <p className="login"> <a href="">Login</a> para deixar um comentário!</p>
      </div>
    )
  }

  componentDidMount () {
    window.scroll(0, 0)
  }
}



// WEBPACK FOOTER //
// ./src/components/blog/recent-posts.js